import { render } from "./rating-stars.html?vue&type=template&id=4521dcf0"
import script from "./RatingStars.vue?vue&type=script&lang=ts"
export * from "./RatingStars.vue?vue&type=script&lang=ts"

import "./rating-stars.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script